import { Box, IconButton, Modal } from "@mui/material";
import { messageModalStyles, previewerStyles } from "./styles";
import { APP_COLOR } from "../../theme";
import CloseIcon from "@mui/icons-material/Close";

export interface PreviewerProps {
  fileUrl: string;
  fileType: "image" | "video" | "pdf" | "text" | "other";
  isPreviewModalOpen: boolean;
  toggle: () => void;
}

const Previewer: React.FC<PreviewerProps> = ({
  fileUrl,
  fileType,
  isPreviewModalOpen,
  toggle,
}) => {
  console.log(fileType);
  return (
    <Modal
      open={isPreviewModalOpen}
      onClose={toggle}
      style={messageModalStyles.modal}
    >
      <Box sx={previewerStyles.mainContainer}>
        <Box sx={previewerStyles.containerWithCloseButton}>
          <IconButton
            onClick={toggle}
            sx={previewerStyles.closeButtonContainer}
          >
            <CloseIcon sx={{ color: APP_COLOR }} />
          </IconButton>

          <Box sx={previewerStyles.previewerContainer}>
            {fileType === "image" && (
              <img src={fileUrl} alt="Preview" style={previewerStyles.image} />
            )}
            {fileType === "pdf" && (
              <Box sx={{ width: "100%", height: "100%" }}>
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`}
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                  title="PDF Preview"
                />
              </Box>
            )}
            {fileType === "video" && (
              <Box sx={previewerStyles.videoContainer}>
                <video controls style={previewerStyles.video}>
                  <source src={fileUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </Box>
            )}
            {fileType === "text" && (
              <iframe
                src={fileUrl}
                width="100%"
                height="100%"
                style={previewerStyles.iframe}
                title="Text Preview"
              />
            )}
            {fileType === "other" && (
              <iframe
                src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                width="100%"
                height="100%"
                style={previewerStyles.iframe}
                title="DOCX Preview"
              />
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default Previewer;
